import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=b28cfa7c&scoped=true"
import script from "./list-item.vue?vue&type=script&lang=js"
export * from "./list-item.vue?vue&type=script&lang=js"
import style0 from "./list-item.vue?vue&type=style&index=0&id=b28cfa7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28cfa7c",
  null
  
)

export default component.exports